export const LogoMark = () => (
    <span className="flex h-10 w-14 shrink-0 items-center justify-center bg-slate-100">
        <img
            src="/logo-hawk-black.png"
            alt="Blackhawk Valves hawk logo"
            className="h-5 w-auto"
            draggable="false"
        />
    </span>
);

export default function Logo({ onClick }) {
    return (
        <button
            data-testid="logo-home-btn"
            onClick={onClick}
            className="flex items-center gap-3 text-left"
        >
            <LogoMark />
            <span className="flex flex-col leading-none">
                <span className="font-display text-xl font-bold uppercase tracking-[0.08em] text-slate-100">
                    Blackhawk
                </span>
                <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.42em] text-amber-500">
                    Valves · UK
                </span>
            </span>
        </button>
    );
}
